import { useEffect } from "react";

const SITE = "https://wanderlyme.com";
const DEFAULT_IMG = `${SITE}/og-default.jpg`;

function upsert(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  type = "website",
  noindex = false,
  robots,
  jsonLd,
}) => {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} · WanderlyMe` : "WanderlyMe · Travel planned around you";
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    document.title = fullTitle;
    upsert('meta[name="description"]', { name: "description", content: description || "" });
    upsert('link[rel="canonical"]', { rel: "canonical", href: url });
    upsert('meta[property="og:type"]', { property: "og:type", content: type });
    upsert('meta[property="og:site_name"]', { property: "og:site_name", content: "WanderlyMe" });
    upsert('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsert('meta[property="og:description"]', { property: "og:description", content: description || "" });
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
    upsert('meta[property="og:image"]', { property: "og:image", content: image });
    upsert('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description || "" });
    upsert('meta[name="twitter:image"]', { name: "twitter:image", content: image });

    const existingRobots = document.head.querySelector('meta[name="robots"]');
    if (robots || noindex) upsert('meta[name="robots"]', { name: "robots", content: robots || "noindex, follow" });
    else if (existingRobots) existingRobots.remove();

    let script = document.head.querySelector("script#seo-jsonld");
    if (ld) {
      if (!script) {
        script = document.createElement("script");
        script.id = "seo-jsonld";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = ld;
    } else if (script) script.remove();
  }, [fullTitle, description, url, image, type, noindex, robots, ld]);

  return null;
};
